import FolderLikedIcon from 'assets/app/library/liked_folder.svg'
import FolderSavedIcon from 'assets/app/library/continue_later_folder.svg'
import { FolderColors } from 'stories/utils/theme'
import { FolderTypes, KnowFolder } from 'interfaces/KnowFolder'
import FolderBlueIcon from 'assets/app/library/blue_folder.svg'
import FolderGreenIcon from 'assets/app/library/green_folder.svg'
import FolderPinkIcon from 'assets/app/library/pink_folder.svg'
import FolderPurpleIcon from 'assets/app/library/violet_folder.svg'
import FolderYellowIcon from 'assets/app/library/yellow_folder.svg'

export const returnFolderIcon = (type: FolderTypes, color: FolderColors) => {
    switch (type) {
        case FolderTypes.LikedKnow:
            return <FolderLikedIcon />
        case FolderTypes.StudyLater:
            return <FolderSavedIcon />
        case FolderTypes.Default:
        default:
            switch (color) {
                case FolderColors.blue:
                    return <FolderBlueIcon />
                case FolderColors.green:
                    return <FolderGreenIcon />
                case FolderColors.pink:
                    return <FolderPinkIcon />
                case FolderColors.yellow:
                    return <FolderYellowIcon />
                case FolderColors.violet:
                    return <FolderPurpleIcon />
                default:
                    return <FolderBlueIcon />
            }
    }
}

export const returnFolderColor = ({ color, type }: KnowFolder) => {
    if (type === FolderTypes.LikedKnow) {
        return FolderColors.pink
    }

    return color
}
